(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneTypeController', PhoneTypeController);

    PhoneTypeController.$inject = ['PhoneType', 'PhoneTypeSearch'];

    function PhoneTypeController(PhoneType, PhoneTypeSearch) {

        var vm = this;

        vm.phoneTypes = [];
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            PhoneType.query(function(result) {
                vm.phoneTypes = result;
                vm.searchQuery = null;
            });
        }

        function search() {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            PhoneTypeSearch.query({query: vm.searchQuery}, function(result) {
                vm.phoneTypes = result;
                vm.currentSearch = vm.searchQuery;
            });
        }

        function clear() {
            vm.searchQuery = null;
            loadAll();
        }    }
})();
